// src/app/redux/reducers/jobSkillReducer.js

import {
    FETCH_JOB_SKILLS_REQUEST, FETCH_JOB_SKILLS_SUCCESS, FETCH_JOB_SKILLS_FAIL,
    CREATE_JOB_SKILL_REQUEST, CREATE_JOB_SKILL_SUCCESS, CREATE_JOB_SKILL_FAIL,
    UPDATE_JOB_SKILL_REQUEST, UPDATE_JOB_SKILL_SUCCESS, UPDATE_JOB_SKILL_FAIL,
    DELETE_JOB_SKILL_REQUEST, DELETE_JOB_SKILL_SUCCESS, DELETE_JOB_SKILL_FAIL,
    IMPORT_JOB_SKILLS_EXCEL_REQUEST, IMPORT_JOB_SKILLS_EXCEL_SUCCESS, IMPORT_JOB_SKILLS_EXCEL_FAIL,
    DOWNLOAD_JOB_SKILLS_TEMPLATE_REQUEST, DOWNLOAD_JOB_SKILLS_TEMPLATE_SUCCESS, DOWNLOAD_JOB_SKILLS_TEMPLATE_FAIL,
    CLEAR_JOB_SKILLS_IMPORT_RESULT,
    SET_JOB_SKILL_LOADING, CLEAR_JOB_SKILL_ERROR,
} from "../actions/jobSkillActions";

const initialState = {
    jobSkills: [],
    importResult: null,
    loading: false,
    error: null,
};

export default function jobSkillReducer(state = initialState, action) {
    switch (action.type) {

        case SET_JOB_SKILL_LOADING:
            return { ...state, loading: action.payload };

        case CLEAR_JOB_SKILL_ERROR:
            return { ...state, error: null };

        case FETCH_JOB_SKILLS_REQUEST:
        case CREATE_JOB_SKILL_REQUEST:
        case UPDATE_JOB_SKILL_REQUEST:
        case DELETE_JOB_SKILL_REQUEST:
        case IMPORT_JOB_SKILLS_EXCEL_REQUEST:
        case DOWNLOAD_JOB_SKILLS_TEMPLATE_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_JOB_SKILLS_SUCCESS:
            return { ...state, loading: false, jobSkills: action.payload || [] };

        case CREATE_JOB_SKILL_SUCCESS:
            return { ...state, loading: false, jobSkills: [...state.jobSkills, action.payload] };

        case UPDATE_JOB_SKILL_SUCCESS:
            return {
                ...state,
                loading: false,
                jobSkills: state.jobSkills.map((js) =>
                    js.id === action.payload.id ? action.payload : js
                ),
            };

        case DELETE_JOB_SKILL_SUCCESS:
            return {
                ...state,
                loading: false,
                jobSkills: state.jobSkills.filter((js) => js.id !== action.payload.id),
            };

        case DOWNLOAD_JOB_SKILLS_TEMPLATE_SUCCESS:
            return { ...state, loading: false };

        case IMPORT_JOB_SKILLS_EXCEL_SUCCESS:
            return { ...state, loading: false, importResult: action.payload };

        case CLEAR_JOB_SKILLS_IMPORT_RESULT:
            return { ...state, importResult: null };

        case FETCH_JOB_SKILLS_FAIL:
        case CREATE_JOB_SKILL_FAIL:
        case UPDATE_JOB_SKILL_FAIL:
        case DELETE_JOB_SKILL_FAIL:
        case IMPORT_JOB_SKILLS_EXCEL_FAIL:
        case DOWNLOAD_JOB_SKILLS_TEMPLATE_FAIL:
            return { ...state, loading: false, error: action.error || "Erreur" };

        default:
            return state;
    }
}